import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages, paramsToSearch } from '@api/utils'

const api = {
  // Création
  comment: (incidentId: string, body: AddCommentIncidentRequest, disableNotifications?: boolean) =>
    ws<CommentaireResponse>(
      config.ws.incident.comment.replace('{incidentId}', incidentId) +
        `?disableNotifications=${disableNotifications || false}`,
      'POST',
      body
    ),
  addFile: (incidentId: string, commentaireId: string, body: PieceJointeCommentaireRequest) =>
    ws<CommentaireResponse>(
      config.ws.incident.addFile.replace('{incidentId}', incidentId).replace('{commentaireId}', commentaireId),
      'POST',
      body
    ),
  addImage: (incidentId: string, body: UploadImageIncidentRequest) =>
    ws<IncidentResponse>(config.ws.incident.addImage.replace('{incidentId}', incidentId), 'POST', body),
  create: (body: CreationIncidentRequest) => ws<IncidentResponse>(config.ws.incident.create, 'POST', body),

  // Lecture
  all: (siteId?: string) =>
    fetchPages<IncidentResponse>('incidents', config.ws.incident.all + `?siteId=${siteId}`, 'GET'),
  get: (id: string) => ws<IncidentResponse>(config.ws.incident.get.replace('{id}', id), 'GET'),
  created: () => fetchPages<IncidentResponse>('incidents', config.ws.incident.created, 'GET'),
  search: (body: IncidentFilterRequest) =>
    fetchPages<IncidentResponse>('incidents', config.ws.incident.search, 'POST', body),
  searchPage: (body: IncidentFilterRequest, page: number, sort: string) =>
    ws<IncidentsListResponse>(config.ws.incident.search + `?page=${page}&sort=${sort}&size=250`, 'POST', body),
  getExpo: (numeroIncident: number) =>
    ws<IncidentResponse>(config.ws.incident.getExpo + `?numeroIncident=${numeroIncident}`, 'GET'),

  // Cycle de vie
  abandon: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.abandon.replace('{incidentId}', incidentId), 'POST'),
  accept: (incidentId: string, body: AcceptIncidentRequest) =>
    ws<IncidentResponse>(config.ws.incident.accept.replace('{incidentId}', incidentId), 'POST', body),
  affect: (incidentId: string, body: AffectationTechnicienIncidentRequest) =>
    ws<IncidentResponse>(config.ws.incident.affect.replace('{incidentId}', incidentId), 'POST', body),
  askQuote: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.askQuote.replace('{incidentId}', incidentId), 'POST'),
  sendQuote: (incidentId: string, body: EnvoieDevisIncidentRequest) =>
    ws<IncidentResponse>(config.ws.incident.sendQuote.replace('{incidentId}', incidentId), 'POST', body),
  closePrestataire: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.closePrestataire.replace('{incidentId}', incidentId), 'POST'),
  closeViparis: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.closeViparis.replace('{incidentId}', incidentId), 'POST'),
  acceptPrestataire: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.acceptPrestataire.replace('{incidentId}', incidentId), 'POST'),
  restart: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.restart.replace('{incidentId}', incidentId), 'POST'),
  treat: (incidentId: string, body: TraitementDevisIncidentRequest) =>
    ws<IncidentResponse>(config.ws.incident.treat.replace('{incidentId}', incidentId), 'POST', body),
  validate: (incidentId: string, body: ValidateIncidentRequest) =>
    ws<IncidentResponse>(config.ws.incident.validate.replace('{incidentId}', incidentId), 'POST', body),
  inaccessibleStand: (incidentId: string, body: StandInaccessibleRequest) =>
    ws<IncidentResponse>(config.ws.incident.inaccessibleStand.replace('{incidentId}', incidentId), 'POST', body),
  reassignProvider: (incidentId: string, body: ReaffectationIncidentRequest) =>
    ws<IncidentResponse>(config.ws.incident.reassignProvider.replace('{incidentId}', incidentId), 'POST', body),

  // Commentaires
  comments: (id: string) =>
    fetchPages<CommentaireResponse>('commentaireList', config.ws.incident.comments.replace('{id}', id), 'GET'),

  // Suivi
  followed: () => fetchPages<IncidentResponse>('incidents', config.ws.incident.followed, 'GET'),
  follow: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.follow.replace('{incidentId}', incidentId), 'POST'),
  unfollow: (incidentId: string) =>
    ws<IncidentResponse>(config.ws.incident.unfollow.replace('{incidentId}', incidentId), 'DELETE'),

  //Statistique
  stats: (siteId: string, manifestationId?: string, tenantId?: string) =>
    ws<IncidentsStatistiquesResponse>(
      config.ws.incident.stats +
        `?siteId=${siteId}${!!manifestationId ? `&manifestationId=${manifestationId}` : ''}${
          !!tenantId ? `&locatairePermanentId=${tenantId}` : ''
        }`,
      'GET'
    ),

  // historique
  history: (incidentId: string) =>
    ws<IncidentHistoryListResponse>(config.ws.incident.history.replace('{incidentId}', incidentId), 'GET'),

  // filtre
  societes: (siteId: string) =>
    fetchPages<IncidentBasicSocieteResponse>(
      'societes',
      config.ws.incident.societes + paramsToSearch({ siteId }),
      'GET'
    ),
}

export default api
